import { render } from "./ParameterTable.vue?vue&type=template&id=e2caf9a6&scoped=true"
import script from "./ParameterTable.vue?vue&type=script&lang=js"
export * from "./ParameterTable.vue?vue&type=script&lang=js"

import "./ParameterTable.vue?vue&type=style&index=0&id=e2caf9a6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2caf9a6"]])

export default __exports__